import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/leuteliaApi";
import { Button } from "@/components/ui/button";
import { Gauge, Loader2 } from "lucide-react";

const STATE = { done: "text-brand-green", error: "text-brand-maroon", skipped: "text-brand-muted" };

export default function ScalaSevera() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const timer = useRef(null);
  const load = async () => {
    try { const d = await api.adminRescale(); setSt(d); if (d.status === "running") timer.current = setTimeout(load, 6000); }
    catch (e) { toast.error(e.message); }
  };
  useEffect(() => { load(); return () => clearTimeout(timer.current); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const start = async () => {
    if (!window.confirm("Rianalizza TUTTI gli hotel reali con la scala severa (foto, analisi profonde, referti). Richiede tempo e credito analisi. Procedere?")) return;
    setBusy(true);
    try { await api.adminRescaleStart({}); toast.success("Rianalisi con la scala severa avviata su tutti gli hotel."); await load(); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const running = st?.status === "running";
  return (
    <div className="bg-white rounded-xl border border-brand-gold/25 p-5 mt-6" data-testid="scala-severa">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2"><Gauge size={18} className="text-brand-gold" /><h3 className="font-serif text-[20px] text-brand-ink">Scala severa su tutti gli hotel</h3></div>
        <Button onClick={start} disabled={busy || running} data-testid="scala-severa-start" className="h-10 rounded-lg bg-brand-green hover:bg-brand-greenDark text-brand-cream text-[13px] font-semibold">
          {running ? <Loader2 size={15} className="mr-2 animate-spin" /> : <Gauge size={15} className="mr-2" />} {running ? "In corso…" : "Rianalizza tutti gli hotel"}
        </Button>
      </div>
      <p className="text-[13px] text-brand-muted mt-1 max-w-3xl">Ogni voto (foto, pagine, post, recensioni, referti) segue la stessa scala severa: ogni errore viene nominato, collegato alle prenotazioni e ai guadagni persi e abbassa il voto. Qui si rianalizzano tutti gli hotel reali con la nuova scala.</p>
      {st && st.status !== "idle" && (
        <div className="mt-4 space-y-2" data-testid="scala-severa-status">
          <div className="text-[12px] text-brand-muted">Stato: <strong className="text-brand-ink">{st.status === "done" ? "completata" : st.status === "running" ? "in corso" : st.status}</strong>{st.started_at ? ` · avviata ${new Date(st.started_at).toLocaleString("it-IT")}` : ""}</div>
          {(st.hotels || []).map((h) => (
            <div key={`${h.tenant}/${h.hotel}`} className="rounded-lg border border-brand-gold/15 px-3 py-2" data-testid={`scala-hotel-${h.hotel}`}>
              <div className="flex items-center justify-between text-[13px]"><span className="font-semibold text-brand-ink">{h.name || h.hotel}</span><span className="text-brand-muted">{h.status}</span></div>
              <ul className="mt-1 grid grid-cols-1 md:grid-cols-2 gap-x-4">{(h.steps || []).map((s, i) => <li key={i} className="text-[11.5px] flex gap-1.5"><span className={STATE[s.state] || "text-brand-muted"}>{s.state === "done" ? "✓" : s.state === "error" ? "✕" : "·"}</span><span className="text-brand-ink">{s.label}</span>{s.note && <span className="text-brand-muted">— {s.note}</span>}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
